import type {RecordEditationAction} from '../types';
import type {RecordEditation} from 'typings/portaro.be.types';

// wrapper export class containing action and corresponding response from server
export class ActionAndResponse {
    constructor(public action: RecordEditationAction, public response: RecordEditation) {
    }
}